module.exports = __webpack_public_path__ + "static/img/3.84926ae.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/18/zh/3.png
// module id = Tzdn
// module chunks = 0